import { dispatchPage } from "./dispatch";
import { getUserTraits } from "./segmentio";
import { PageOptions } from "./types";

export function page(data: PageOptions = {}): void {
  try {
    const userTraits = getUserTraits();
    const optionalProperties = data.properties ? data.properties : {};
    const combinedProperties = { ...userTraits, ...optionalProperties };
    dispatchPage(data.name, combinedProperties);
  } catch (error) {
    console.error("Failed to track page event.", error);
  }
}
